async function apiGet(path) {
    const r = await fetch(path, { credentials: "include" });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data?.error || `GET ${path} failed`);
    return data;
}

async function apiPost(path, body) {
    const r = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(body ?? {}),
    });

    const text = await r.text(); // <-- on lit brut
    let data = {};
    try { data = JSON.parse(text); } catch { }

    if (!r.ok) {
        throw new Error(data?.error || text || `POST ${path} failed`);
    }
    return data;
}


export const api = {
    me: () => apiGet("/api/me.php"),
    login: (password) => apiPost("/api/login.php", { password }),
    logout: () => apiPost("/api/logout.php", {}),
    listStudents: async () => (await apiGet("/api/students.php")).students,
    updateStudent: (patch) => apiPost("/api/student-update.php", patch),
    reset: (type) => apiPost("/api/reset.php", { type }),
};
